// class while ad uploading
export class AdForm {
    public name: string;
    public regions: Array<any> = [];
    public devices: Array<any> = [];
    public budget: number = null;
    //PAKISTAN PILOT REMOVAL: public pay_with: string = "card";
    public pay_with: string = "invoice";
    public tax: number;
    public company_name: string = "";
    public company_vat: string = "";
    public company_address: string = "";
    public company_zip: string = "";
    public company_city: string = "";
    public company_country: string = "";
    public save_details: boolean = false;
    public agree: boolean = false;
    public potentialCost: number = 0;
    public maxCost: number = 0;

    public orientation: string = "vertical";

    public card_data: CardData = new CardData();

    //PAKISTAN VERTICAL: public display_orientation: string = "display_ver";
    public display_orientation: string = "display_hor";

    //public targetAds: TargetAd[] = [];
    public targetInfo: {
        index: number,
        title: string,
        target_group: {
            male: any,
            female: any,
        },
    }[] = [];
}

export class CardData {
    public encryptedCardNumber: string = '';
    public encryptedExpiryMonth: string = '';
    public encryptedExpiryYear: string = '';
    public encryptedSecurityCode: string = '';
    public holderName: string = '';
}




// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/upload/adform.ts